var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "#45C777",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.5C4.02955 0.5 0 4.52955 0 9.5C0 14.4705 4.02955 18.5 9 18.5C13.9705 18.5 18 14.4705 18 9.5C18 4.52955 13.9705 0.5 9 0.5ZM12.9011 7.97818C12.9729 7.89607 13.0276 7.80042 13.0619 7.69687C13.0963 7.59331 13.1095 7.48393 13.1009 7.37517C13.0924 7.26641 13.0621 7.16046 13.012 7.06356C12.9619 6.96666 12.8929 6.88076 12.8091 6.81092C12.7253 6.74107 12.6283 6.6887 12.524 6.65687C12.4196 6.62504 12.31 6.61441 12.2015 6.62559C12.0929 6.63677 11.9877 6.66954 11.8921 6.72197C11.7964 6.77441 11.7122 6.84545 11.6444 6.93091L8.12618 11.1519L6.30573 9.33064C6.15142 9.1816 5.94474 9.09913 5.73022 9.10099C5.51569 9.10286 5.31048 9.18891 5.15878 9.3406C5.00709 9.4923 4.92104 9.69751 4.91918 9.91204C4.91731 10.1266 4.99978 10.3332 5.14882 10.4875L7.60336 12.9421C7.68376 13.0224 7.78 13.0851 7.88598 13.1262C7.99195 13.1673 8.10532 13.1859 8.21886 13.1807C8.3324 13.1756 8.44362 13.1468 8.54543 13.0963C8.64724 13.0458 8.7374 12.9746 8.81018 12.8873L12.9011 7.97818Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.8390c9eb.svg";
export { ForwardRef as ReactComponent };